<template>
  <div>
    <b-form @submit="onSubmit">
      <b-form-group
        id="password"
        :label="$t('wifi.password')"
        label-for="password"
      >
        <b-form-input
          id="password"
          v-model="form.password"
          :type="passwordFieldType"
          required
          :placeholder="$t('wifi.passwordEnter')"
        ></b-form-input>
        <b-checkbox @change="onShowPassword($event)">
          {{ $t('wifi.passwordShow') }}
        </b-checkbox>
      </b-form-group>

      <b-button type="submit" variant="primary">{{ $t('wifi.connect') }}</b-button>
    </b-form>
  </div>
</template>

<script>

export default {
  name: 'SetupWifiCredentialsWPA',
  data() {
    return {
      form: {
        encryption: 'wpa-psk',
        password: '',
      },
      passwordFieldType: 'password'
    }
  },
  methods: {
    onSubmit() {
      this.$emit('connect', this.form);
    },
    onShowPassword(val) {
      this.passwordFieldType = val ? 'text' : 'password';
    }
  }
}
</script>
